import React, { Fragment, useEffect, useState } from "react";

/**
 * Components
 */
import GuyFailedPath from "../../assets/svg/guy_failed.svg";
import GuyFailedScheduledPath from "../../assets/svg/guy_failed_sched.svg";
import BaseButton from "../../components/base-button/base-button";
import useModal from "../../hooks/use-modal";
import API from "../../utils/api";

const ModalPaymentFailed = (props) => {
  const { closeModal } = useModal();
  const { updateMethod, notToday, alert } = props.modalProps;
  const [alertDetails, setAlertDetails] = useState({});

  const _updateMethod = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      updateMethod();
    } catch (e) {
      console.log(e);
    }
  };

  const _closeModal = async () => {
    try {
      await API.put(`/alerts/${alert.id}/dismiss`);
      notToday();
    } catch (e) {
      console.log(e);
    }
    closeModal();
  };

  useEffect(() => {
    if (alert.params && alert.params.length > 0) {
      const newAlertDetails = {};
      for (const param of alert.params) {
        newAlertDetails[param.name] = param.value;
      }
      setAlertDetails(newAlertDetails);
    }
  }, []);

  return (
    <Fragment>
      <div style={{ textAlign: "center" }}>
        <img
          src={alertDetails["plan_id"] ? GuyFailedScheduledPath : GuyFailedPath}
          width={200}
          alt={"picture of a guy"}
        />
        <h1
          style={{
            color: "#272643",
            fontWeight: "lighter",
            marginTop: "10px",
            marginBottom: "10px",
          }}
        >
          {alertDetails["plan_id"]
            ? "Your scheduled payment has failed and your payment plan is at risk."
            : "Your scheduled payment has failed."}
        </h1>
        <p>We will try again. Do you want to update your payment method?</p>
        <BaseButton
          type="button"
          className="btn--primary"
          style={{ marginTop: "30px" }}
          onClick={_updateMethod}
        >
          Update Payment Method
        </BaseButton>
        <p
          style={{ marginTop: "10px", cursor: "pointer" }}
          onClick={_closeModal}
        >
          Not today
        </p>
      </div>
    </Fragment>
  );
};

export default ModalPaymentFailed;
